module.exports = __webpack_public_path__ + "static/event-surge-8c6e35887eb2439d97f816b35419d5cd.jpg";